<header>
  <app-admin-header></app-admin-header>
</header>
<main>
  <app-breadcrumb></app-breadcrumb>
  <router-outlet></router-outlet>
</main>
<footer>
  <app-footer></app-footer>
</footer>
